import { Button } from 'antd'
import React from 'react'
import IntlMessages from '../../util/IntlMessages'
import './toast.css'

const NewSiteToast = () => {
	const newWebsiteUrl = process.env.REACT_APP_NEW_SITE_URL
	const token = localStorage.getItem('userKey')
	const hasModalBeenShown = localStorage.getItem('websiteModalShown')
	return (
		<div
			className='new-site-toast'
			style={{
				display: hasModalBeenShown ? 'flex' : 'none',
				gap: '10px',
				alignItems: 'center',
				justifyContent: 'center',
				backgroundColor: '#F4E1BE',
				color: '#212B36',
				position: 'sticky',
				width: '100%',
				top: 0,
				zIndex: 20
			}}
		>
			<p style={{ margin: 0 }}>
				<IntlMessages id='new.site.toast.message' />
			</p>
			<Button
				size='middle'
				onClick={() => {
					window.open(
						`${newWebsiteUrl}/user/from-old-site/${
							token ? token : 'not-signed-in'
						}`
					)
				}}
				style={{
					margin: 0,
					background: 'white',
					color: '#B3641B',
					border: 'none',
					borderRadius: '8px'
				}}
			>
				<IntlMessages id='new.site.toast.button' />
			</Button>
		</div>
	)
}

export default NewSiteToast
